
import PT from 'prop-types';

export const EventInfoModelShape = PT.shape({
    EventDateID: PT.number
});

export const PlaceToGoEnum = {
    CONTINUE_SHOPPING: "CONTINUE_SHOPPING",
    GO_TO_CHECKOUT: "GO_TO_CHECKOUT",
    GO_TO_CART: "GO_TO_CART"
};
